import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { HookCityReducer } from "./hook-city/slice";
import { UserReducer } from "./user-details/slice";
import { AddToCartReducer } from "./add-to-cart/slice";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { cartReducer } from "./cart/slice";
import { appointmentReducer } from "./pet-ct-appointment/slice";
import { abhaReducer } from "./abha/slice";
import { appointmentNewReducer } from "./pet-ct-appointment-new/slice";

// Persist configuration
const persistConfig = {
    key: "root",
    storage, // This tells redux-persist to use localStorage
    version: 1,
    whitelist: ["hookCity", "user", "addToCart"], // List slices you want to persist
};

const rootReducer = combineReducers({
    hookCity: HookCityReducer,
    user: UserReducer, // Use the persisted reducer here
    addToCart: AddToCartReducer,
    cart: cartReducer,
    appointment: appointmentReducer,
    appointmentNew: appointmentNewReducer,
    abha: abhaReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

const Store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
            },
        }),
});

// const Store = configureStore({
// 	reducer: persistedReducer,
// });

export const persistor = persistStore(Store);

export default Store;
